import {
  Infinity as InfinityIcon, FileX, Unplug, ArrowLeftRight, Gauge, Headset,
  Network, Radar, Boxes, Wrench, Wifi, Zap, DollarSign, RefreshCw, ShieldCheck, Building2,
} from "lucide-react";

const MAP = {
  Infinity: InfinityIcon, FileX, Unplug, ArrowLeftRight, Gauge, Headset,
  Network, Radar, Boxes, Wrench, Wifi, Zap, DollarSign, RefreshCw, ShieldCheck, Building2,
};

export default function DynIcon({ name, ...props }) {
  const Cmp = MAP[name] || Wifi;
  return <Cmp {...props} />;
}
